import { useState } from 'react';
import akcoda from '../../assets/AKCODA-02.png';
import whatsapp from '../../assets/whatsapp/whatsapp.png';
import email from '../../assets/whatsapp/email.png';
import phone from '../../assets/whatsapp/phone.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const [show, setShow] = useState(false);

  const handleBurger = () => {
    setShow(prev => !prev);
  };

  return (
    <>
      {/* WhatsApp Icon */}
      <div className='whatsappicon p-2 position-fixed' style={{bottom: 150, zIndex: 999 }}>
        <a href="https://wa.me/+918851042421" target='_blank' className='d-flex' rel='noopener noreferrer'>
          <img src={whatsapp} alt="whatsapp"/> 
        </a>

        <a href="tel:8851042421" className='d-flex mt-3' rel='noopener noreferrer'>
          <img src={phone} alt="whatsapp"/> 
        </a>
      </div>

      <header style={{background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)"}} className='sticky-top'>
        <div className="container d-flex justify-content-between align-items-center p-2">
          {/* Logo */}
          <div>
            <Link to="/">
              <img src={akcoda} alt="akcoda" style={{borderRadius:'10px', width: '120px', height: '60px' }} />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="d-none d-md-block">
            <ul
              className="d-flex align-items-center m-0"
              style={{ gap: "10px", listStyle: "none", color: "#ffffff" }}
            >
              <li>
                <Link to="/" style={{ color: "#ffffff", fontWeight: "500" }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/service" style={{ color: "#ffffff", fontWeight: "500" }}>
                  About
                </Link>
              </li>

              {/* Services Mega Menu */}
              <div className="dropdown" >
                <button className="btn dropdown-toggle text-light" type="button" data-bs-toggle="dropdown" aria-expanded="false" 
                 style={{color:'#ffffff', fontWeight:'500'}}
                >
                  Services
                </button>
                <ul className="dropdown-menu"  style={{width:'250%', padding:'10px'}}> 
                  <li>=> <Link to="/website" style={{ color: "#111111ff", fontWeight: "500" }}>
                    Website Development
                  </Link></li>
                  <li>=> <Link to="/androidios" style={{ color: "#111111ff", fontWeight: "500" }}>
                    Mobile App Development
                  </Link></li>
                  <li>=> <Link to="/ecommerce" style={{ color: "#111111ff", fontWeight: "500" }}>
                    Ecommerce Development
                  </Link></li>
                  <li>=> <Link to="/contact" style={{ color: "#111111ff", fontWeight: "500" }}>
                    Custome Development
                  </Link></li>
                </ul>
              </div>

              <li>
                <Link to="/blog" style={{ color: "#ffffff", fontWeight: "500" }}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" style={{ color: "#ffffff", fontWeight: "500" }}>
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="tel:8700364602"
                  className="glow-button"
                  style={{
                    color: "#090909ff",
                    padding: "10px",
                    background: "linear-gradient(to right, #426fecff ,  #f4f5f7ff)",
                    fontWeight: "600",
                  }}
                >
                  Get a Free Consultation!
                </a>
              </li>
            </ul>
          </div>


          {/* Burger Icon */}
          <div className="d-md-none">
            <button onClick={handleBurger} className="btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {show && (
          <div className="container d-md-none">
            <ul className='p-3' style={{ listStyle: 'none'}}>
              <li><Link to="/" style={{color:'#ffffff', fontWeight:'500'}}>Home</Link></li>
              <li><Link to="/service" style={{color:'#ffffff', fontWeight:'500'}}>About</Link></li>
              <li>
                <details>
                  <summary style={{color:'#ffffff', fontWeight:'500'}}>Services</summary>
                  <ul style={{ listStyle: 'none', paddingLeft: '15px' }}>
                    <li><Link to="/website" style={{color:'#ffffff', fontWeight:'500'}}>Website Development</Link></li>
                    <li><Link to="/ecommerce" style={{color:'#ffffff', fontWeight:'500'}}>Ecommerce Development</Link></li>
                    <li><Link to="/androidios" style={{color:'#ffffff', fontWeight:'500'}}>Android/iOS App Development</Link></li>
                  </ul>
                </details>
              </li>
              <li><Link to="/blog" style={{color:'#ffffff', fontWeight:'500'}}>Blog</Link></li>
              <li><Link to="/contact" style={{color:'#ffffff', fontWeight:'500'}}>Contact</Link></li>
              {/* <li><Link to="/contact" style={{color:'#ffffff', fontWeight:'500'}}>Website / Automation</Link></li> */}
              <li><a href="tel:8700364602" className='glow-button' style={{color:'#090909ff', padding:'10px', background: 'linear-gradient(to right, #426fecff ,  #f4f5f7ff)', fontWeight:'600'}}>Get a Free Consultation!</a></li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
